import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { SecurityRoleGuard } from './guards/security-role.guard';

export const routes: Routes = [
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./components/acces-denied/access-denied.component').then(
        (m) => m.AccessDeniedComponent
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./components/initial-redirect/initial-redirect.component').then(
        (m) => m.InitialRedirectComponent
      ),
  },
  {
    path: 'payroll',
    loadComponent: () =>
      import('./modules/payroll/payroll.component').then(
        (m) => m.PayrollComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'payroll/integrations/monitoring',
    loadComponent: () =>
      import('./modules/payroll/integrations/integrations.component').then(
        (m) => m.IntegrationsComponent
      ),
    canActivate: [SecurityRoleGuard],
    data: { monitoring: true },
  },
  {
    path: 'payroll/integrations/:processId',
    loadComponent: () =>
      import('./modules/payroll/integrations/integrations.component').then(
        (m) => m.IntegrationsComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'payroll/integrations/:processId/:id',
    loadComponent: () =>
      import(
        './components/process-monitor/process-details/process-details.component'
      ).then((m) => m.ProcessDetailsComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'compensation',
    loadComponent: () =>
      import('./modules/compensation/compensation.component').then(
        (m) => m.CompensationComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'workday',
    loadComponent: () =>
      import('./modules/workday/workday.component').then(
        (m) => m.WorkdayComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'workday/eib-builder',
    loadComponent: () =>
      import('./modules/workday/eib-builder/eib-builder.component').then(
        (m) => m.EibBuilderComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'people-data',
    loadComponent: () =>
      import('./modules/people-data/people-data.component').then(
        (m) => m.PeopleDataComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'people-data/mass-taxonomy-updates',
    loadComponent: () =>
      import(
        './modules/people-data/mass-taxonomy-updates/mass-taxonomy-updates.component'
      ).then((m) => m.MassTaxonomyUpdatesComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'people-data/single-taxonomy-update',
    loadComponent: () =>
      import(
        './modules/people-data/single-taxonomy-update/single-taxonomy-update.component'
      ).then((m) => m.SingleTaxonomyUpdateComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'people-data/audit/:processId',
    loadComponent: () =>
      import('./modules/people-data/audit/audit.component').then(
        (m) => m.AuditComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'people-data/audit/:processId/:id',
    loadComponent: () =>
      import(
        './components/process-monitor/process-details/process-details.component'
      ).then((m) => m.ProcessDetailsComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'system',
    loadComponent: () =>
      import('./modules/system/system.component').then(
        (m) => m.SystemComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'system/security-roles',
    loadComponent: () =>
      import('./modules/system/security-roles/security-roles.component').then(
        (m) => m.SecurityRolesComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'system/impersonation-management',
    loadComponent: () =>
      import(
        './modules/system/impersonation-management/impersonation-management.component'
      ).then((m) => m.ImpersonationManagementComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'system/process-monitor',
    loadComponent: () =>
      import('./modules/system/process-monitor/process-monitor.component').then(
        (m) => m.ProcessMonitorComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'system/process-monitor/:processId/:processName',
    loadComponent: () =>
      import(
        './modules/system/process-monitor/process-detail/process-detail.component'
      ).then((m) => m.ProcessDetailComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'system/process-monitor/:processId/:processName/:id',
    loadComponent: () =>
      import(
        './modules/system/process-monitor/execution-details/execution-details.component'
      ).then((m) => m.ExecutionDetailsComponent),
    canActivate: [SecurityRoleGuard],
  },
  ...(environment.showFeatureBranchExplorer
    ? [
        {
          path: 'system/branch-explorer',
          loadComponent: () =>
            import(
              './modules/system/branch-explorer/branch-explorer.component'
            ).then((m) => m.BranchExplorerComponent),
          canActivate: [SecurityRoleGuard],
        },
      ]
    : []),
  {
    path: 'talent-management',
    loadComponent: () =>
      import('./modules/talent-management/talent-management.component').then(
        (m) => m.TalentManagementComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/technologies',
    loadComponent: () =>
      import(
        './modules/talent-management/technologies/technologies.component'
      ).then((m) => m.TechnologiesComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/skills',
    loadComponent: () =>
      import('./modules/talent-management/skills/skills.component').then(
        (m) => m.SkillsComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/certifications',
    loadComponent: () =>
      import(
        './modules/talent-management/certifications/certifications.component'
      ).then((m) => m.CertificationsComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/industries',
    loadComponent: () =>
      import(
        './modules/talent-management/industries/industries.component'
      ).then((m) => m.IndustriesComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/roles',
    loadComponent: () =>
      import('./modules/talent-management/roles/roles.component').then(
        (m) => m.RolesComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/jobs/organizations',
    loadComponent: () =>
      import(
        './modules/talent-management/job/job-organizations/job-organizations.component'
      ).then((m) => m.JobOrganizationsComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/jobs/organizations/:id',
    loadComponent: () =>
      import(
        './modules/talent-management/job/job-organization-detail/job-organization-detail.component'
      ).then((m) => m.JobOrganizationDetailComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/jobs/family-groups/:id',
    loadComponent: () =>
      import(
        './modules/talent-management/job/job-family-group-detail/job-family-group-detail.component'
      ).then((m) => m.JobFamilyGroupDetailComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/jobs/families/:id',
    loadComponent: () =>
      import(
        './modules/talent-management/job/job-family-detail/job-family-detail.component'
      ).then((m) => m.JobFamilyDetailComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'talent-management/jobs/profiles/:id',
    loadComponent: () =>
      import(
        './modules/talent-management/job/job-profile-detail/job-profile-detail.component'
      ).then((m) => m.JobProfileDetailComponent),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'learning',
    loadComponent: () =>
      import('./modules/learning/learning.component').then(
        (m) => m.LearningComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'learning/paths',
    loadComponent: () =>
      import('./modules/learning/learning-paths/learning-paths.component').then(
        (m) => m.LearningPathsComponent
      ),
    canActivate: [SecurityRoleGuard],
  },
  {
    path: 'learning/promoted',
    loadComponent: () =>
      import(
        './modules/learning/promoted-learning/promoted-learning.component'
      ).then((m) => m.PromotedLearningComponent),
    canActivate: [SecurityRoleGuard],
  },
  { path: '**', redirectTo: '' },
];
